/* Section « Vidéo en boucle » (vidéo décorative, non interactive) :
   - ne charge la vidéo que lorsqu'elle approche de l'écran (économise la bande passante)
   - la lance seulement quand elle est visible, la met en pause quand elle sort de l'écran
   - choisit la source adaptée à l'écran (ordinateur / mobile)
   - respecte « réduire les animations » : seule l'image d'aperçu est affichée */
(function () {
  if (window.__detlightVideoLoopLoaded) return;
  window.__detlightVideoLoopLoaded = true;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const isMobile = () => mobileQuery.matches;

  function setup(video) {
    if (video.dataset.detlightReady) return;
    video.dataset.detlightReady = 'true';

    const sourceUrl = () => (isMobile() && video.dataset.srcMobile) || video.dataset.srcDesktop || '';

    if (isMobile() && video.dataset.posterMobile) video.poster = video.dataset.posterMobile;

    // « Réduire les animations » : on laisse uniquement l'image d'aperçu
    if (reduceMotion) return;

    let visible = false;

    function load() {
      const url = sourceUrl();
      if (!url || video.getAttribute('src') === url) return;
      video.setAttribute('src', url);
      video.load();
    }

    function play() {
      const attempt = video.play();
      if (attempt && typeof attempt.catch === 'function') attempt.catch(function () {});
    }

    // Passage mobile <-> ordinateur (rotation, redimensionnement)
    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', function () {
        if (!visible) return;
        load();
        play();
      });
    }

    if (!('IntersectionObserver' in window)) {
      load();
      play();
      return;
    }

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          visible = entry.isIntersecting;
          if (visible) {
            load();
            play();
          } else if (!video.paused) {
            video.pause();
          }
        });
      },
      { rootMargin: '200px 0px', threshold: 0.15 }
    );
    observer.observe(video);
  }

  function init(root) {
    root.querySelectorAll('video[data-detlight-video]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  // Éditeur de thème : réinitialise quand la section est rechargée
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
